var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{ref:"myIframe",staticStyle:{"height":"100vh","width":"100vw"},attrs:{"src":"/unity/index.html","scrolling":"0"},on:{"load":_vm.sendMessage}})])
}
var staticRenderFns = []

export { render, staticRenderFns }